import update from 'immutability-helper'

import { USER_TYPE, LIST_TYPE } from '../constant'


const defaultState = {
  page: 0,
  count: 0,
  data: [],
  user: null,
  client: null,
  waitingProfiles: [],
  chunkFinished: true,
  collection: 'models',
  userType: USER_TYPE.MODEL,
}


export default function admin(state = defaultState, action) {
  switch (action.type) {
    case 'GET_LIST': return {
      ...state,
      page: 0,
      count: 0,
      data: [],
      collection: action.collection,
    }

    case 'BROWSE_WAITING_PROFILES_SUCCESS': return {
      ...state,
      waitingProfiles: action.data,
    }

    case 'GET_LIST_SUCCESS': return {
      ...state,
      data: action.data,
      count: action.count,
    }

    case 'UPDATE_LIST': return {
      ...state,
      data: [],
    }

    case 'UPDATE_LIST_CHUNK': return {
      ...state,
      data: state.data.concat(action.data),
      chunkFinished: action.chunkFinished || false,
    }

    case 'UPDATE_LIST_SUCCESS': return {
      ...state,
      page: action.page,
      data: action.data,
      chunkFinished: true,
    }

    case 'GET_CLIENT_SUCCESS': return {
      ...state,
      client: action.data,
    }

    case 'GET_USER': return {
      ...state,
      user: null,
    }

    case 'GET_CHUNK_USER': return {
      ...state,
      user: action.data,
    }

    case 'GET_USER_SUCCESS': return {
      ...state,
      user: {
        ...(state.user || {}),
        ...action.data,
      },
    }

    case 'EDIT_FOLIO': return update(state, {
      user: {
        folios: {
          [state.user.folios.findIndex(folio => folio.objectID === action.folio.objectID)]: {
            $set: action.folio,
          },
        },
      },
    })

    case 'EDIT_USER': return {
      ...state,
      user: action.user,
    }

    case 'DECLINE_PERMISSION':
    case 'VALIDATE_PERMISSION': return {
      ...state,
      user: state.user && state.user.objectID === action.userId ? {
        ...state.user,
        permission: action.permission,
      } : state.user,
      data: state.collection === LIST_TYPE.WAITINGLIST ? state.data.filter(d => d.objectID !== action.userId) : state.data,
    }

    default: return state
  }
}
